import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckBox from '../../../../components/Checkbox';
import { fetchMiddlePanelNotesData, resetMiddlePanel } from "../../../../containers/WorkkardDetail/actions/action";
import { DigestNoteFilters } from '../../../../common/util';
import Icon from '../../../../icons';
import { useModules } from '../../../../utils/modules';
const NoteFilters = (props) => {
  const { isModuleEnabled } = useModules();

  let filterRef = useRef(null);
  const dispatch = useDispatch();
  const [allSelected, setSelector] = useState(false);
  const [filterModified, setModification] = useState(false);
  const [reviewFilterOptions, setReviewFilters] = useState([
    { id: 1, label: "Reviewed", checked: true },
    { id: 2, label: "Not Reviewed", checked: true }
  ]);
  const [currentNoteFilters, setNoteFilters] = useState([]);
  const type = useSelector((state) => state.workkardDetail.middlePanel.notes.type);
  const cId = useSelector((state) => state.workkardDetail.workkardDetail.Id);
  const ActivityDetail = useSelector((state) => state.workkardDetail.activityDetail);



  let findCheckAll = (array) => {
    if (array.some((element) => !element.checked && element.isVisible)) {
      return false;
    } else {
      return true;
    }
  };


  let addNoteFilters = (array, item, checked, isVisible) => {
    array.push({
      id: item.Id,
      label: item.NoteTemplateName,
      checked,
      IsSystem: item.IsSystem,
      isVisible: props.OwnerOrgId == item.OrganizationId?isVisible :false,
      TemplateShortName: item.TemplateShortName
    });
  };


  const onSave = () => {
    //let deSelectall = currentNoteFilters.every((e) => !e.checked);
    let noteFilters = Array.from(new Set(currentNoteFilters.filter((element) => !element.checked && element.id > 0).map((element) => element.id)));
    let payload = {};
    let rw = reviewFilterOptions.filter((x) => x.checked);
    rw = rw.length == 1 ? rw[0].id : 0;
    payload.request = {
      type,
      cId,
      actId: ActivityDetail.activityId,
      skip: 0,
      take: 10,
      reviewFilter: rw ? rw : 0,
      sortBy: "0"
    };
    payload.request.noteFilters = noteFilters.toString();
    payload.updateFiltersAPI = {
      data: []
    };
    //check fro any saved filter for b2b cases
    let hiddenFilters = props?.excludedFilters?.filter(x => !currentNoteFilters.filter((element) => element.id > 0).map((element) => element.TemplateShortName).includes(x))    
    payload.updateFiltersAPI.data.push({
      activity_template_id: ActivityDetail.activityTemplateType,
      deselected_note_template_ids: Array.from(new Set(currentNoteFilters.filter((element) => !element.checked && element.id > 0).map((element) => element.TemplateShortName))).concat(hiddenFilters)
    });
    payload.excludedFilters = DigestNoteFilters(payload.updateFiltersAPI.data);
    dispatch(resetMiddlePanel({ type: "notes", value: "activity" }));
    dispatch(fetchMiddlePanelNotesData(payload));
    props.onSave(rw);
    props.closeFilter(); // hide filter modal
    // dispatch(updateExcludedFilters({[ActivityDetail.TemplateId]:noteFilters}))
  };

  const handleCheckboxChange = (item) => {
    /*for handling checkbox behaviour this function will invoke in 2 cases
    1. when Select ALL or Unselect all will be clicked
    2.then specific item will be clicked
    */
    let ModifiedNoteFilters = [...currentNoteFilters];
    let currentexCludedFilter = props.excludedFilters;
    let checkedall = allSelected;

    //implementation for case 1 * when select all/unselect all clicked * when we have to check on uncheck all Notes and there matching shortname templates to handle b2b cases when template id will be different
    if (item === true || item === false) {
      checkedall = item;
      if (ModifiedNoteFilters.some(x => x.isVisible && x.checked != item)) {

        ModifiedNoteFilters.forEach((ele) => {
        ele.checked = item;
        });
      }
    }
    //implementation for case 2 when any specific Note will be clicked  then state will be modifed.
    //and (only applicable in b2b activities-->) there respective shortname note emplate of diff org which is hidden will be marked same as Current Note Tempalte.
    else {
      let status = item.checked;
      ModifiedNoteFilters.forEach((element) => element.checked = element.TemplateShortName === item.TemplateShortName ? !status : element.checked);
      if (item.id === 0) {
        ModifiedNoteFilters.forEach((element) => {
          if (element.IsSystem) {
            element.checked = item.checked;
          }
        });
      }
      checkedall = findCheckAll(ModifiedNoteFilters);
    }
    // below code is to identify any chanages in filters to reduce duplicate calls
    let newKeys = ModifiedNoteFilters.filter((x) => !x.checked && x.id > 0).map(x => x.TemplateShortName);
    if (currentexCludedFilter?.every((value) => newKeys.includes(value)) && newKeys.every((value) => currentexCludedFilter.includes(value))) {
      setModification(false);
    } else {
      setModification(true);
    }
    //updating the modified state
    setSelector(checkedall);
    setNoteFilters(ModifiedNoteFilters);
  };

  // below code  will invoke only when review filters altered
  let ChangeReviewFilter = (e) => {
    reviewFilterOptions.forEach((element) => {
      if (element.id === e.id) element.checked = !element.checked;
    });
    let rw = reviewFilterOptions.filter((x) => x.checked);
    rw = rw.length == 1 ? rw[0].id : 0;
    if (rw != props.reviewfilter) {
      setModification(true);
    } else {
      setModification(false);
    }
    setReviewFilters([...reviewFilterOptions]);
  };


  let renderChecks = (item, handleCheckbox) => {
    return (
      <>
      <CheckBox item={item} handleCheckbox={handleCheckbox}/>
        {item.label == "System Note" && <em class="quickTooltip-bottom" data-quicktooltip="This is a set of system-generated notes like Activity reopen, reassignment, closure, etc.">
        <Icon name="info" className="icon ml greyInfoIcon" />
        </em>}
      </>
    );
  };



  let handleOutsideClick = (e) => {
    if (filterRef.current && !filterRef.current.contains(e.target)) {
      props.closeFilter();
      document.removeEventListener("mousedown", handleOutsideClick);
    }
  };



  useEffect(() => {
    let NoteTemplates = props.currentNoteTemplates;
    const sortedNoteTemplates = [...NoteTemplates].sort((a, b) => a.NoteTemplateName.localeCompare(b.NoteTemplateName));
    document.addEventListener("mousedown", handleOutsideClick);
    let sysNoteExists = sortedNoteTemplates.some((x) => x.IsSystem);
    let initalFilters = [];
    sysNoteExists && initalFilters.push({ id: 0, label: "System Note", TemplateShortName: "sysfilenote", isVisible: true });
    /*we will itrate all note templates which can be at max 2 orgs  in such a way that a unique templateshortname aka Note templates will be visible and other will be hidden 
    same as System notes */
    sortedNoteTemplates &&
      sortedNoteTemplates.forEach((element) => {
        if (props.excludedFilters?.includes(element.TemplateShortName)) {
          if (!element.IsSystem && !initalFilters.some((x) => x.TemplateShortName == element.TemplateShortName && x.isVisible)) {
            addNoteFilters(initalFilters, element, false, true);
          } else {
            addNoteFilters(initalFilters, element, false, false);
          }
        } else {
          if (!element.IsSystem && !initalFilters.some((x) => x.TemplateShortName == element.TemplateShortName && x.isVisible)) {
            addNoteFilters(initalFilters, element, true, true);
          } else {
            addNoteFilters(initalFilters, element, true, false);
          }
        }
      });
    //if any of system note is marked as true then rest will be same 
    initalFilters[0].checked = sysNoteExists
      ? initalFilters.some((element) => element.IsSystem && element.checked)
      : initalFilters[0].checked;
    let checkedall = findCheckAll(initalFilters);
    let reviewFilter = [...reviewFilterOptions];
    reviewFilter.forEach((x) => x.id == props.reviewfilter ? (x.checked = true) : props.reviewfilter == 0 ? x.checked = true : x.checked = false);
    setReviewFilters(reviewFilter);
    setNoteFilters(initalFilters);
    setSelector(checkedall);
  }, [props.reviewfilter]);




  return (
    <div className="colFlex filterScroll" ref={filterRef}>
      {isModuleEnabled("notes.filters.review_type") && reviewFilterOptions.length && (
        <>
          <label className="filtersPl">Filters</label>
          <div className="rowFlex dropDownMenu">
            {reviewFilterOptions.map((item) => (
              <span key={item.id} className="mr__1">
                {renderChecks(item, ChangeReviewFilter)}
              </span>
            ))}
          </div>
        </>
      )}
      {isModuleEnabled("notes.filters.note_types") && <>
      <div className="alignMiddle filterSticky">
        <label>Note Type</label>{" "}
        <a
          className="ml pointer"
          onClick={() => handleCheckboxChange(!allSelected)}>
          {allSelected ? "unselect all" : "select all"}
        </a>
      </div>
      <div className="filterCheck dropDownMenu">
        {
          <ul className="rowFlex">
            {currentNoteFilters.map((item) => (item.isVisible &&
              <li key={item.id}>
                <span>{renderChecks(item, handleCheckboxChange)} </span>
              </li>
            ))}
          </ul>
        }
      </div>
      </>}
      <footer className="filterSticky">
        <div className="actions alignRight">
          <a
            className="pointer btn buttonGradient"
            href="javascript:void(0)"
            onClick={filterModified ? onSave : props.closeFilter}>
            Done
          </a>
          <a
            className="btn link"
            href="javascript:void(0)"
            onClick={props.closeFilter}>
            Cancel
          </a>
        </div>
      </footer>
    </div>
  );
};

export default NoteFilters;
